import { useEffect } from "react"

const reCaptchaV3siteKey = '6Lf21DcfAAAAAAMxbWvPewB5wcV8U4tSvfck1AQR';
export const grecaptcha = () => {
    window.grecaptcha.ready(function () {
        window.grecaptcha.execute(reCaptchaV3siteKey, { action: 'homepage' }).then(function (token) {
            document.getElementById('re_captcha_v3_token').value = token;
            if (document.getElementsByClassName('grecaptcha-badge')[0]) document.getElementsByClassName('grecaptcha-badge')[0].style.display = ''
        });
    });
}
export function ReCaptchaV3() {

    useEffect(() => {
        if (window.grecaptcha) {
            grecaptcha();
        } else {
            const scriptTag = document.createElement('script');
            scriptTag.type = 'text/javascript';
            scriptTag.id = 'recaptchaV3';
            scriptTag.src = `https://www.google.com/recaptcha/api.js?render=${reCaptchaV3siteKey}`;

            scriptTag.addEventListener('load', () => {
                grecaptcha();
            });

            (document.head || document.body).appendChild(scriptTag);
        }
        return () => {
            if (document.getElementsByClassName('grecaptcha-badge')[0]) document.getElementsByClassName('grecaptcha-badge')[0].style.display = 'none'
        }
    }, []);

    return <input type="hidden" name="re_captcha_v3_token" id="re_captcha_v3_token" />;
}